<template>
  <div class="alert alert-warning">
    <template v-if="loading">
      <Skeleton />
      <div class="row align-items-center">
        <small class="col-md-12 text-center">Carregando...</small>
      </div>
    </template>

    <div v-else class="row align-items-center">
      <div class="col-md-8 d-flex align-items-center">
        <span class="alert-icon">⚠️</span>
        <span class="alert-label text-muted">Boletos vencendo:</span>
        <template v-if="showCount">
          <span class="alert-value">{{ selectData.count || 0 }}</span>
          <span class="alert-separator">|</span>
          <span class="alert-label text-muted">Total:</span>
        </template>
        <span class="alert-total font-weight-bold">{{ selectData.sum || 0 | price }}</span>
      </div>

      <div class="col-md-4 d-flex justify-content-end align-items-center">
        <span class="period-label text-muted mr-2">Período:</span>
        <select v-model="selectData.days" class="form-control form-control-sm alert-select">
          <option v-for="option in selectData.options" :value="option.value" :key="option.value">
            {{ option.label }}
          </option>
        </select>
        <info-icon class="ml-2" v-tooltip.top="tooltipDescription()" />
      </div>
    </div>
  </div>
</template>

<script>
import { InfoIcon } from 'vue-feather-icons'
import Skeleton from '@/components/utils/Skeleton.vue'

export default {
  created() {
    this.selectData = this.data
  },
  components: { InfoIcon, Skeleton },
  data: () => ({
    selectData: {}
  }),
  methods: {
    tooltipDescription() {
      return 'Baseado na data atual. Mostra o total de boletos que vencerão no período selecionado a partir de hoje'
    }
  },
  name: 'FutureAlert',
  props: {
    data: { required: true, type: Object },
    loading: { required: true, type: Boolean },
    showCount: { required: false, type: Boolean, default: true }
  }
}
</script>

<style scoped>
.alert {
  background-color: var(--alert-warning-bg) !important;
  border-color: var(--alert-warning-border) !important;
  color: var(--alert-warning-text) !important;
}

.alert-icon {
  font-size: 1.2rem;
  margin-right: 0.75rem;
}

.alert-label {
  font-size: 0.875rem;
  margin-right: 0.5rem;
  color: var(--text-muted) !important;
}

.alert-value {
  font-size: 1.25rem;
  font-weight: bold;
  color: var(--alert-warning-text) !important;
  margin-right: 1rem;
}

.alert-total {
  font-size: 1.1rem;
  color: var(--alert-warning-text) !important;
}

.alert-separator {
  margin: 0 1rem;
  color: var(--alert-warning-separator) !important;
  font-weight: 300;
}

.alert-select {
  width: 100px;
  height: 30px;
  font-size: 0.875rem;
  border-color: var(--alert-warning-border) !important;
  background-color: var(--form-control-bg) !important;
  color: var(--form-control-text) !important;
}

.alert-select:focus {
  border-color: var(--alert-warning-border) !important;
  box-shadow: 0 0 0 0.2rem var(--alert-warning-shadow) !important;
}

.period-label {
  font-size: 0.875rem;
  color: var(--text-muted) !important;
}

.text-muted {
  color: var(--text-muted) !important;
}
</style>
